import { useLocation } from 'react-router-dom';
import { useMemo, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setNotification } from '../actions/appNotifications';

export const useQuery = () => {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
};

export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

export const useOnClickOutside = (ref, handler, excludeClass, altExcludeClass) => {
  useEffect(() => {
    const listener = (event) => {
      if (
        !ref.current ||
        ref.current.contains(event.target) ||
        document.getElementsByClassName(excludeClass)?.[0]?.contains(event.target) ||
        document.getElementsByClassName(altExcludeClass)?.[0]?.contains(event.target)
      ) {
        return;
      }
      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

export const useNotifications = (pending, error, successConfig, errorConfig) => {
  const dispatch = useDispatch();
  const previous = usePrevious({ pending, error });

  useEffect(() => {
    if (previous?.pending && !pending && !error) {
      dispatch(setNotification(successConfig));
    }
    if (previous?.pending && !pending && error) {
      dispatch(setNotification(errorConfig));
    }
  }, [pending, error]);
};
